<template>
  <ul :class="[{ [$style.listHighlighted]: mode === 'select' || hoverable }]">
    <li
      v-for="user in users"
      :key="user.userId"
      :class="[$style.item, { [$style.itemActive]: isPicked(user) }, 'gl-user-list-item']"
      @click="onClick(user)"
    >
      <slot name="avatar" :user="user">
        <Avatar :user="user" :size="avatarSize" isShowOnline :class="$style.avatar" />
      </slot>
      <div :class="$style.info">
        <div :class="$style.name">
          <slot name="role" :user="user">{{ getUserDisplayName(user) }}</slot>
          <!--          {{user}}-->
        </div>
        <div
          v-if="user.displayName !== user.phone && user.phone && !user.phone.startsWith('+202')"
          :class="$style.meta"
        >
          {{ user.phone }}
        </div>
      </div>
      <BaseIcon v-if="mode === 'select'" name="check" :class="[$style.checkIcon]" />
      <div :class="$style.action">
        <slot :user="user" />
      </div>
    </li>
    <infinite-loading v-if="infiniteHandler" :class="$style.infiniteLoading" @infinite="infiniteHandler">
      <Spinner slot="spinner" />
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </ul>
</template>

<script>
import Avatar from '@/components/Avatar'
import { TYPE_CODE } from '@/models/Chat'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/Spinner'
import { getUserDisplayName } from '@/utils/helpers'

export default {
  name: 'user-list',
  components: {
    Avatar,
    InfiniteLoading,
    Spinner
  },
  props: {
    users: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      validator: value => ['profile', 'chat', 'select', 'disable'].includes(value),
      default: 'profile'
    },
    selectedUsers: {
      type: Array
    },
    hoverable: Boolean,
    avatarSize: {
      type: Number,
      default: 44
    },
    infiniteHandler: Function,
    chatId: {
      type: [Number, String]
    }
  },
  computed: {
    selectedUsersLocal: {
      get () {
        return this.selectedUsers
      },
      set (value) {
        this.$emit('update:selectedUsers', value)
      }
    }
  },
  methods: {
    getUserDisplayName,
    onClick (user) {
      switch (this.mode) {
        case 'profile':
          return this.showProfile(user)
        case 'chat':
          return this.goChat(user)
        case 'disable':
          return false
        case 'select':
          return this.selectUser(user)
        default:
          return this.showProfile(user)
      }
    },
    showProfile (user) {
      this.$modal.show('profile', {
        userId: user.userId,
        chatId: this.chatId
      })
    },
    async goChat (user) {
      const chat = await this.$store.dispatch('entities/chats/create', {
        type: TYPE_CODE['one-to-one'],
        participants: [user.userId]
      })
      this.$router.push({ name: 'app-chat', query: { id: window.btoa(chat.id) } }).catch(e => {})
      this.$emit('go-to-chat', chat)
    },
    selectUser (user) {
      const idx = this.pickedIndex(user)
      if (idx > -1) {
        this.selectedUsersLocal.splice(idx, 1)
      } else {
        this.selectedUsersLocal.push(user.userId)
      }
    },
    pickedIndex (user) {
      if (!this.selectedUsersLocal) return
      return this.selectedUsersLocal.indexOf(user.userId)
    },
    isPicked (user) {
      if (!this.selectedUsersLocal) return
      return this.pickedIndex(user) > -1
    }
  }
}
</script>

<style lang="scss" module>
.listHighlighted .item:hover {
  background-color: rgba($main-bg-colored, 0.2);
}
.item {
  display: flex;
  padding: 15px 0;
  cursor: pointer;
  // align-items: center;
  &Active {
    background-color: rgba($main-bg-colored, 0.2);
    .checkIcon {
      opacity: 1;
    }
  }
}
.avatar {
  margin-right: 8px;
  flex-shrink: 0;
}
.info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
}
.action {
  flex-shrink: 0;
  text-align: right;
}

.name {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 6px;
  width: 100%;
}
.meta {
  color: $text-mid;
}
.checkIcon {
  opacity: 0;
  font-size: 20px;
  color: $text-colored;
}
.infiniteLoading {
  height: 50px;
  padding: 20px 0;
  margin: 0 auto;
}
</style>
